import React, { useEffect, useState } from 'react';
import { BehaviorSubject } from 'rxjs';
import { ModalInner } from './modal-inner';
import { ModalSetting } from './modal.type';

export const modalSubject = new BehaviorSubject<ModalSetting[]>([]);

export function ModalContainer() {
  const [modalList, setModalList] = useState<ModalSetting[]>([]);

  useEffect(() => {
    modalSubject.subscribe((modalList) => {
      setModalList(modalList);
    });
  }, []);

  return (
    <div className='modal-container'>
      {modalList.map((modal, idx) => (
        <ModalInner key={idx} modal={modal} />
      ))}
    </div>
  );
}
